import { Component, OnInit } from '@angular/core';
import { ContestWiseHandler } from './contestWise.handler.';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';
import { BaseService } from 'src/app/system-common/services/base.service';

@Component({
  selector: 'sym-ContestWise',
  templateUrl: './contestWise.component.html',
  styleUrls: ['./contestWise.component.scss'],
})
export class ContestWiseComponent extends ContestWiseHandler implements OnInit {
  constructor(
    public service: BaseService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, headerService, router, settingService, offlineService);
  }
}
